import { connect } from "react-redux";
import { DanhSachTaiSan } from "components/DanhSachTaiSan";
import { getListTaiSan } from "actions/DanhSachTaiSan";

const mapStateToProps = (state) => ({
  DanhSachTaiSan: state.DanhSachTaiSan,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListTaiSan: (dataSearch) => dispatch(getListTaiSan(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachTaiSan);
